import classnames from "classnames";

import style from "./style.module.scss";
import type { ButtonProps } from "../../types";

function Button({
  href,
  className,
  isInverted,
  isPrimary,
  isDisabled,
  isSecondary,
  isLarge,
  isBorderless,
  children,
  ...props
}: ButtonProps) {
  const classes = classnames(style.button, className, {
    [style.isInverted]: isInverted,
    [style.isPrimary]: isPrimary,
    [style.isSecondary]: isSecondary,
    [style.isLarge]: isLarge,
    [style.isBorderless]: isBorderless,
  });

  if (href && !isDisabled) {
    return (
      <a className={classes} href={href}>
        {children}
      </a>
    );
  }

  return (
    <button disabled={isDisabled} className={classes} {...props}>
      {children}
    </button>
  );
}

export default Button;
